import { render, staticRenderFns } from "./ErrorCircleIcon.vue?vue&type=template&id=0b170b70"
import script from "./ErrorCircleIcon.vue?vue&type=script&lang=js"
export * from "./ErrorCircleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports